<template>
  <v-layout row wrap align-center v-on:keyup.enter="queryPECourseInfo">
    <v-flex md2>
      <v-text-field
        :label="labels.course_title"
        v-model="course_name"
      ></v-text-field>
    </v-flex>
    <v-flex md2>
      <v-text-field
        :label="labels.instructor"
        v-model="course_teacher"
      ></v-text-field>
    </v-flex>
    <v-flex md1>
      <v-btn round :disabled="btn_state" v-on:click="queryPECourseInfo()">
        <v-icon>search</v-icon>
        {{ labels.search }}
      </v-btn>
    </v-flex>
    <v-flex md1></v-flex>
    <v-flex md2 align-self-center>
      <v-tooltip top>
      <template v-slot:activator="{ on }">
          <div v-on="on">
              <v-btn flat
                     href="https://dss20.ntust.edu.tw/edua/courlist/qry_coursebook.aspx?fid=2&sid=1&tid=1">
                  <v-icon left>cloud_download</v-icon>
                  {{ labels.pe_class_time_table }}
              </v-btn>
          </div>
      </template>
      <span> {{ labels.download_info}}</span>
    </v-tooltip>
    </v-flex>
    <v-flex md2 align-self-center>
      <v-tooltip top>
      <template v-slot:activator="{ on }">
          <div v-on="on">
              <v-btn flat
                     href="https://dss20.ntust.edu.tw/edua/courlist/qry_coursebook.aspx?fid=2&sid=1&tid=2">
                  <v-icon left>cloud_download</v-icon>
                  {{ labels.pe_class_quota }}
              </v-btn>
          </div>
      </template>
      <span> {{ labels.download_info}}</span>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
import languages from "../../languages/TabPE.json";

export default {
  data: () => ({
    labels: {
      course_title: "",
      instructor: "",
      search: "",
      pe_class_time_table: "",
      pe_class_quota: "",
    },
    course_name: "",
    course_teacher: "",
  }),
  computed: {
    btn_state() {
      return this.$store.state.btn_state;
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
  },
  methods: {
    queryPECourseInfo: function () {
      var query_params = {
        Semester: this.$store.state.select_semester,
        CourseNo: "PE",
        CourseName: this.course_name,
        CourseTeacher: this.course_teacher,
        Dimension: "",
        CourseNotes: "",
        ForeignLanguage: 0,
        OnlyGeneral: 0,
        OnleyNTUST: 0,
        OnlyMaster: 0,
        Language: this.select_language.lang,
      };
      this.$store.dispatch("queryCourseInfo", query_params);
    },
    setLanguage: function (select_language) {
      this.labels.course_title = languages.course_title[select_language.lang];
      this.labels.instructor = languages.instructor[select_language.lang];
      this.labels.search = languages.search[select_language.lang];
      this.labels.pe_class_time_table =
        languages.pe_class_time_table[select_language.lang];
      this.labels.pe_class_quota =
        languages.pe_class_quota[select_language.lang];
      this.labels.download_info =
        languages.download_info[select_language.lang];
    },
  },
};
</script>
